module.exports = __webpack_public_path__ + "img/Russian Federation.dcd637a2.gif";